import { useTranslation } from "react-i18next";

type TProps = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalSecondsLeft: number;
};

const BannerTitleTimeCountdown = (timeLeft: TProps) => {
  const { t } = useTranslation("class_banner");

  const ONE_DAY_IN_SECONDS = 24 * 60 * 60;

  const TimeLeftUntilStart = () => {
    const hours =
      timeLeft.hours < 10 ? `0${timeLeft.hours}` : `${timeLeft.hours}`;
    const minutes =
      timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : `${timeLeft.minutes}`;
    const seconds =
      timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : `${timeLeft.seconds}`;
    return t(
      "This class will start in {{ hours }}:{{ minutes }}:{{ seconds }}",
      {
        hours,
        minutes,
        seconds,
      }
    );
  };
  const DaysLeftUntilStart = t(
    `Your next class will start in {{ days }} ${
      timeLeft.days === 1 ? "day" : "days"
    }`,
    {
      days: timeLeft.days,
      count: timeLeft.days,
    }
  );

  if (timeLeft.totalSecondsLeft > ONE_DAY_IN_SECONDS) return DaysLeftUntilStart;
  if (timeLeft.totalSecondsLeft > 0) return TimeLeftUntilStart();

  // If time's up
  return t("Your class has started!");
};

export default BannerTitleTimeCountdown;
